import Api from 'libs/api';

class FiltersApi extends Api {
  constructor() {
    super('admin/filters/');
  }
}

export default FiltersApi;
